import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { TranslateService } from "../../services/translate.service";
//import {MatSnackBar} from "@angular/material/snack-bar";
import { SnackbarService } from '../../services/snackbar.service';
import { PhoneUtils } from "../../utils/Utils";
import { VenueConfig } from "../../models/FSConfig";
import { PageButtonComponent } from '../buttons/page-button.component';
import { CommonModule } from '@angular/common';
import { FormsModule, NonNullableFormBuilder } from '@angular/forms';
import { CircleButtonComponent } from "../buttons/circle-button.component";
import { AppStateService } from '../../services/app-state.service';
import { AppState } from '../../models/AppState';
import { Subscription } from 'rxjs';
import { UrlHistoryService } from '../../services/url.history.service';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';
import {SmallActionButtonComponent} from '../buttons/small-action-button.component';
import {ActionButtonComponent} from '../buttons/action-button.component';
import { BottomSheetService } from '../../services/bottom-sheet.service';

@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [
    PageButtonComponent,
    FormsModule,
    CommonModule,
    CircleButtonComponent,
    LoadingSpinnerComponent,
    SmallActionButtonComponent,
    ActionButtonComponent
  ],
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit, OnDestroy {
  @Input() popCount: number = 1; // How many bottomsheets to pop when done
  phoneNumber: string | null = null;
  verificationCode: string | null = null;
  sentCode = false;
  loginPhone = false;
  isAndroid = false;
  phoneLoginError: string | null = null;
  useTeleLogin = false;
  @Input() config: VenueConfig | null = null;
  waiting = false;
  appState?: AppState;
  sub: Subscription | null = null;


  constructor(
    public authService: AuthService,
    private translate: TranslateService,
    private snackbarService: SnackbarService,
    private sheetService: BottomSheetService,
    private appStateService: AppStateService,
    private identityService: UrlHistoryService,
  ) { }

  ngOnInit(): void {
    this.sub = this.appStateService.observeAppState().subscribe(appState => {
      this.appState = appState;
      this.useTeleLogin = appState.cfg.features?.use_tele_login ?? false;
    });
    this.authService.initializeRecaptcha('recaptcha-container');
    this.isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1;
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  getString(s: string) {
    return this.translate.single(s);
  }

  signInWithProvider(provider: 'apple' | 'google'): void {
    console.log(`Starting sign-in with provider: ${provider}`);
    this.waiting = true;
    const authMethod = provider === 'apple' ? this.authService.appleAuth() : this.authService.googleAuth();
    authMethod.then(() => {
      console.log(`Inloggad med ${provider}, popCount=${this.popCount}`);
      this.sheetService.popSheet(this.popCount);
    }).catch((error) => {
      console.error(`${provider}-auth fel:`, error);
    });
  }

  sendCode() {
    this.phoneLoginError = null;
    let E164;
    try {
      if (this.phoneNumber) {
        E164 = PhoneUtils.convertNumberIntoE164Format(this.phoneNumber);
      }
      if (!E164) {
        throw new Error("Ogiltigt telefonnummer");
      }
    } catch (e) {
      this.phoneLoginError = "Angivet telefonnummer är inte korrekt";
      return;
    }

    this.waiting = true;
    console.log(`sendCode to ${this.phoneNumber} (${E164})`);
    this.authService.sendVerificationCode(E164).then(res => {
      this.waiting = false;
      this.sentCode = true;
    }).catch((error) => {
      console.error('Error during signInWithPhoneNumber', error);
      const errMsg = error?.message ?? "Ett okänt fel inträffade.";
      this.phoneLoginError = `Angivet telefonnummer är inte korrekt eller annat fel inträffade. ${errMsg}`;
      this.waiting = false;
      this.sentCode = false;
    });
  }

  onCodeChange() {
    if (this.verificationCode && this.verificationCode.length === 6) {
      this.verifyCode();
    }
  }

  verifyCode() {
    this.waiting = true;
    this.phoneLoginError = null;
    const codePattern = /^\d{6}$/;
    if (!this.verificationCode || !codePattern.test(this.verificationCode)) {
      this.phoneLoginError = "Angiven kod är inte korrekt";
      this.waiting = false;
      return;
    }
    if (this.verificationCode) {
      this.authService.verifyCode(this.verificationCode).then(res => {
        console.log('Code verified', res);
        this.waiting = false;
        this.sheetService.popSheet(this.popCount);
      }).catch((error) => {
        this.waiting = false;
        console.error('Error while verifying code', error);
        
        // Provide more specific error messages based on the error type
        if (error.message && error.message.includes('No confirmation result available')) {
          this.phoneLoginError = "Verifieringsprocessen har avbrutits. Begär en ny kod.";
        } else if (error.message && error.message.includes('Verification timeout')) {
          this.phoneLoginError = "Verifieringen tog för lång tid. Försök igen.";
        } else if (error.code === 'auth/invalid-verification-code') {
          this.phoneLoginError = "Angiven kod är inte korrekt";
        } else if (error.code === 'auth/code-expired') {
          this.phoneLoginError = "Koden har gått ut. Begär en ny kod.";
        } else {
          this.phoneLoginError = "Angiven kod är inte korrekt";
        }
      });
    }
  }

  selectPhoneLogin() {
    this.loginPhone = true;
  }
}
